import React from "react";
import { BLACK } from "@streeteasy/design-system/colors";
import ArrowIcon from "@streeteasy/design-system/deprecated/Icons/SVG/ArrowIcon";
import { oneOf, string } from "prop-types";

import { theme } from "./styled";
import * as S from "./styled";

const Tag = props => {
  const arrowDirection = props.type === "priceDecrease" ? "down" : "up";

  return (
    <S.TagContainer type={props.type}>
      {["priceDecrease", "priceIncrease"].includes(props.type) && (
        <ArrowIcon
          designFillColor={BLACK}
          desktopPadding="6px 4px 6px 0"
          direction={arrowDirection}
          width="8px"
        />
      )}
      <S.TagText>{props.text}</S.TagText>
    </S.TagContainer>
  );
};

Tag.propTypes = {
  text: string.isRequired,
  type: oneOf(Object.keys(theme)).isRequired
};

export default Tag;
